<template>
  <div :class="bem.b()">
    <!-- 顶部 -->
    <div
      :class="bem.e('top')"
      :style="{
        height: addUnit(topHeight),
        marginBottom: addUnit(verticalSpace),
      }"
    >
      <slot name="top" />
    </div>

    <div :class="bem.e('content')">
      <slot name="content" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { addUnit, createNamespace } from '@ll-plus/utils'
import { verticalLayoutProps } from './vertical-layout'

defineOptions({ name: 'LlVerticalLayout' })

const bem = createNamespace('vertical-layout')

defineProps(verticalLayoutProps)
</script>
